import { render } from "./ProdukNav.vue?vue&type=template&id=d38b1800"
import script from "./ProdukNav.vue?vue&type=script&lang=js"
export * from "./ProdukNav.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__